import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ratnaImage from '../../../../images/discovery/ratna.svg';
import { setShowBuyRatnaModalLeftSection, showBuyRatnaModal } from '../../../../redux/user/userActions';
import ButtonComponent from '../../../common-components/ButtonComponent/ButtonComponent';
import IconContainer from '../../../common-components/FtuxComponent/IconContainer';
import ModalComponent from '../../../common-components/ModalComponent/ModalComponent';

import '../styles/_outofRatnaModal.scss';

import { GLEAP_UPGRADE_ACCOUNT_FORM_KEY } from '@/utils/ts/gleap';
import dayjs from 'dayjs';
import Gleap from 'gleap';

import SupportIcon from '@/components/Icons/icons/SupportIcon';

export default function OutofRatnaModal({ show, handleClose, darkMode = false }) {
  const { userDetails } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const isActiveUser = Boolean(userDetails?.subscriptionStatus === 'active');

  const ratnaCount = userDetails?.plan?.ratnaCount;

  const getRenewalDate = () => {
    if (userDetails?.nextFreeCreditRatnaAt) {
      const targetDate = dayjs.unix(userDetails?.nextFreeCreditRatnaAt);
      const today = dayjs();
      const daysRemaining = targetDate.diff(today, 'day');
      return daysRemaining;
    } else {
      return 'few';
    }
  };

  if (isActiveUser) {
    return (
      <ModalComponent show={show} onClose={handleClose} width={425} style={{ padding: 0 }} bodyStyle={{ padding: 0 }}>
        <div className="out-of-ratna-modal">
          <IconContainer icon="⚠️" bgColor="#FEFCE8" />
          <h3 className="modal-title">Whoops, you’re out of Ratna!</h3>
          <p className="out-of-ratna-modal-desc">
            On your current plan, you can save {ratnaCount} influencers each month. Looks like you’re out of Ratna for
            the month. They refresh in {getRenewalDate()} days from now.
          </p>
          <p className="out-of-ratna-modal-desc">
            You can buy more Ratna or upgrade to a higher package which gives you more volume per month.
          </p>
          <div
            className="modal-footer-button-container"
            style={{
              flexDirection: 'row',
              alignItems: 'stretch',
            }}>
            <ButtonComponent
              style={{ flex: 1 }}
              onClick={() => {
                dispatch(setShowBuyRatnaModalLeftSection('buy-ratna'));
                dispatch(showBuyRatnaModal(darkMode ? 'dark' : 'light'));
              }}
              variant="primary-outline">
              Buy One-Time
            </ButtonComponent>
            <ButtonComponent
              style={{ flex: 1 }}
              type="submit"
              onClick={() => {
                Gleap.setTicketAttribute('Intent', 'I want to upgrade my account');
                Gleap.startClassicForm(GLEAP_UPGRADE_ACCOUNT_FORM_KEY, true);
                handleClose();
              }}>
              Upgrade Plan
            </ButtonComponent>
          </div>
        </div>
      </ModalComponent>
    );
  }

  return (
    <ModalComponent
      show={show}
      onClose={handleClose}
      width={425}
      outsideClickClose={false}
      style={{ padding: 0 }}
      bodyStyle={{ padding: 0 }}>
      <div className="out-of-ratna-modal">
        <IconContainer icon="⚠️" bgColor="#FEFCE8" />
        <h3 className="modal-title">Whoops, you’re out of trial credits!</h3>
        <div className="balance-section">
          <h4 className="balance-tag">Currrent Balance</h4>
          <div className="ratnas">
            <img src={ratnaImage} alt="ratna" className="ratna-img" />
            <p className="ratna-balance-count">{userDetails?.balance}</p>
          </div>
        </div>
        <p className="out-of-ratna-modal-desc first">
          Ratna is our in-app credit system. You get to save {ratnaCount} influencers per month on the base plan. Right
          now, on the free trial, you can save and reach out to 50 influencers to test. You’ve done that.
        </p>
        <p className="out-of-ratna-modal-desc">Want us to activate your account so you can save {ratnaCount} more?</p>
        <div
          className="modal-footer-button-container"
          style={{
            flexDirection: 'row',
            alignItems: 'stretch',
          }}>
          <ButtonComponent style={{ flex: 1 }} onClick={handleClose} variant="secondary">
            No, go back
          </ButtonComponent>
          <ButtonComponent
            style={{ flex: 1 }}
            type="submit"
            onClick={() => dispatch(showBuyRatnaModal(darkMode ? 'dark' : 'light'))}>
            Yes, Activate!
          </ButtonComponent>
        </div>
        <div
          className="support-tag"
          onClick={() => {
            Gleap.setTicketAttribute('Intent', 'My Ratna ran out on the trial account. Need help!');
            Gleap.startClassicForm(GLEAP_UPGRADE_ACCOUNT_FORM_KEY, true);
            handleClose();
          }}>
          <SupportIcon />
          Contact Support
        </div>
      </div>
    </ModalComponent>
  );
}
